import { Alert } from '@piggytechng/component-library';
import { localStorageEnum } from '../../api/enums';
import { httpClient } from '../../api/http';
import { encryptData, loginEncyptionKey } from './crypto-js';

// Credentials for privileged endpoints, always built from a just-typed password.
const LEGACY_CREDENTIAL_KEYS = ['password-en', 'encryptionKey', 'identifier-en'];

export const purgeCredentials = () => {
  LEGACY_CREDENTIAL_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const getAuthIdentifier = () => {
  const email = localStorage.getItem(localStorageEnum['local.storage.email']);
  if (!email) fail('Session expired. Please log in again.');
  return encryptData(email as string, loginEncyptionKey);
};

export const authPayload = (typedPassword: string) => ({
  identifier: getAuthIdentifier(),
  password: encryptPassword(typedPassword),
});

/** For the few endpoints that take a password but no identifier. */
export const encryptPassword = (typedPassword: string) => {
  if (!typedPassword) fail('Please enter your password to proceed.');
  return encryptData(typedPassword, loginEncyptionKey);
};

export const verifyAdminPassword = async (typedPassword: string): Promise<boolean> => {
  try {
    const response = await httpClient.post<any>('admin/auth-check', authPayload(typedPassword));

    if (response?.data?.status) return true;

    console.log('verifyAdminPassword failed', response?.data);

    Alert.error(response?.data?.message || 'Please, enter a valid password.');
    return false;
  } catch {
    return false;
  }
};

function fail(message: string): never {
  Alert.error(message);
  throw new Error(message);
}
